import { useStorage } from '@vueuse/core'
import { defineStore } from 'pinia'

const useSettingsStore = defineStore('settings', () => {
  const accountLayout = useStorage('accountLayout', {
    card: true,
    list: false,
    group: false,
  })

  const assetToggle = useStorage('assetToggle', {
    toggle: false,
  })
  return {
    accountLayout,
    assetToggle,
  }
})

export { useSettingsStore }
